<template>
    <div class="waba-supsis-auth-intl-price-eligibility-update">
        <div class="title">{{ $t("auto.whatsappBusinessApiV2InternationalPriceEligibilityUpdate") }}</div>
        <div class="meta">
            <div><b>{{ $t("auto.event") }}</b>: {{ $_.get(activity, "payload.event") }}</div>
            <div><b>{{ $t("auto.channelId") }}</b>: {{ $_.get(activity, "payload.channelId") }}</div>
            <div><b>{{ $t("auto.startTime") }}</b>: {{ $_.get(activity, "payload.auth_international_rate_eligibility.start_time") }}</div>
            <div v-if="exceptionCountries.length > 0">
                <b>{{ $t("auto.exceptionCountries") }}</b>:
                <ul>
                    <li v-for="(country, index) in exceptionCountries" :key="index">
                        {{ country.country_code }} ({{ $t("auto.startTime") }}: {{ country.start_time }})
                    </li>
                </ul>
            </div>
        </div>
        <details class="raw">
            <summary>{{ $t("auto.rawPayload") }}</summary>
            <pre>{{ prettyPayload }}</pre>
        </details>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WabaSupsisAuthIntlPriceEligibilityUpdate",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        exceptionCountries() {
            return this.$_.get(this.activity, "payload.auth_international_rate_eligibility.exception_countries", []);
        },
        prettyPayload() {
            try {
                return JSON.stringify(this.$_.get(this.activity, "payload", {}), null, 2);
            } catch (e) {
                return String(this.$_.get(this.activity, "payload", ""));
            }
        },
    },
});
</script>

<style scoped lang="scss">
.waba-supsis-auth-intl-price-eligibility-update {
    .title {
        font-weight: 600;
        margin-bottom: 6px;
    }
    .meta {
        display: flex;
        flex-direction: column;
        gap: 2px;
        margin-bottom: 8px;
        ul {
            margin: 4px 0;
            padding-left: 20px;
        }
    }
    .raw {
        pre {
            max-height: 240px;
            overflow: auto;
            padding: 10px;
            border: 1px solid var(--color-border-default);
            border-radius: 6px;
            background: var(--color-bg-neutral-default);
        }
        summary {
            cursor: pointer;
            user-select: none;
            margin-bottom: 6px;
        }
    }
}
</style>
